
import * as THREE from 'three'
import Experience from '../../Experience'
export default class Road {
    constructor(_options) {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.ressources = this.experience.ressources
        this.time = this.experience.time
        // 


        this.targetPos = _options.targetPos
        this.materials = _options.materials
        this.setMesh()

    }
    setMesh() {
        this.roadBrickGeometry = this.ressources.items.road.scene.children[0].geometry
        this.roadMaterial = this.materials.road
        this.count = 20

        this.mesh = new THREE.InstancedMesh(this.roadBrickGeometry, this.roadMaterial, this.count)
        this.instancePositions = []

        // 
        this.position = new THREE.Vector3(0, 0, 0)
        this.rotation = new THREE.Euler(0, 0, 0)
        this.quaternion = new THREE.Quaternion().setFromEuler(this.rotation)
        this.scale = new THREE.Vector3(0.5, 0.5, 0.5)
        this.mat = new THREE.Matrix4()

        for (let i = 0; i < this.count; i++) {
            this.position.set((i * 1.01) - (this.count / 2), -3, 0)
            this.rotation.set(0, 0, 0)
            this.quaternion.setFromEuler(this.rotation)
            this.mat.compose(this.position, this.quaternion, this.scale)
            this.mesh.setMatrixAt(i, this.mat)
            this.instancePositions.push(this.position.clone())
        }

        this.mesh.instanceMatrix.needsUpdate = true
        // retirer le frustrumCalling de la camera pour rendre les instances indéfinniment
        this.mesh.frustumCulled = false
        this.mesh.layers.enable(1)

        this.scene.add(this.mesh)

    }
    destroy() {
        if (this.mesh) {
            this.scene.remove(this.mesh)

            // Dispose geometry
            this.mesh.geometry?.dispose?.()

            // Dispose material
            if (Array.isArray(this.mesh.material)) {
                this.mesh.material.forEach(m => m.dispose?.())
            } else {
                this.mesh.material?.dispose?.()
            }

            this.mesh = null
        }

        // Vider les tableaux et références
        this.instancePositions = null
        this.roadBrickGeometry = null
        this.roadMaterial = null
        this.mat = null
        this.position = null
        this.rotation = null
        this.quaternion = null
        this.scale = null

        this.experience = null
        this.scene = null
        this.ressources = null
        this.time = null
        this.targetPos = null
        this.materials = null
    }


    update() {
        const centerX = this.targetPos.x - 6
        // send targetPos to the material
        this.materials.road.uniforms.u_targetPos.value.copy(this.targetPos)


        // Trouver l'instance la plus à gauche
        let minX = Infinity
        let minIndex = -1
        for (let i = 0; i < this.count; i++) {
            if (this.instancePositions[i].x < minX) {
                minX = this.instancePositions[i].x
                minIndex = i
            }
        }


        // Vérifier si cette instance est proche ou derrière le centre
        if (this.instancePositions[minIndex].x < centerX) {
            // Trouver la plus grande position x actuelle
            let maxX = -Infinity
            for (let pos of this.instancePositions) {
                if (pos.x > maxX) maxX = pos.x
            }

            // Repositionner l'instance en dehors du groupe, à droite
            this.instancePositions[minIndex].x = maxX + 1.01 // distance d'espacement

            // Recomposer et appliquer la nouvelle matrice
            this.position.copy(this.instancePositions[minIndex])

            this.mat.compose(this.position, this.quaternion, this.scale)
            this.mesh.setMatrixAt(minIndex, this.mat)
        }
        for (let i = 0; i < this.count; i++) {
            const pos = this.instancePositions[i];

            const dist = pos.distanceTo(this.targetPos);


            // Y cible selon distance (plus proche → plus haut)
            const targetY = dist < 6 ? -1.5 : -2.5;

            // interpolation fluide vers la bonne hauteur
            pos.y = THREE.MathUtils.lerp(pos.y, targetY, 0.1);

            // Appliquer la matrice
            this.position.set(pos.x, pos.y, pos.z);
            this.rotation.set(0, 0, 0);
            this.quaternion.setFromEuler(this.rotation);
            this.mat.compose(this.position, this.quaternion, this.scale);
            this.mesh.setMatrixAt(i, this.mat);
        }
        this.mesh.instanceMatrix.needsUpdate = true

    }


}